import { Preview, Span, excerpt } from './model';
export function reviewWork(p: Preview) {
  const turns = p.turns.filter(t => t.role === 'dialogue');
  const unknown = turns.filter(t => t.state === 'unknown').length;
  const suggested = turns.filter(t => t.state === 'suggested').length;
  return { unknown, suggested, reviewed: turns.length - unknown - suggested,
    requiredSpeakerDecisions: unknown + suggested, requiredBoundaryAttestations: p.boundariesReviewed ? 0 : 1,
    structuralWarnings: p.warnings.filter(w => !w.startsWith('Sentence boundaries are conservative')).length };
}
export function storyContext(p: Preview, span: Span) {
  const first = p.paragraphs.findIndex(x => x.span[1] > span[0]);
  const last = p.paragraphs.findIndex(x => x.span[1] >= span[1]);
  const start = p.paragraphs[Math.max(0, first - 1)].span[0];
  const end = p.paragraphs[Math.min(p.paragraphs.length - 1, last + 1)].span[1];
  return { before: excerpt(p.source.text, [start, span[0]]), focus: excerpt(p.source.text, span), after: excerpt(p.source.text, [span[1], end]) };
}
